import {
  CButton,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
} from "@coreui/react"
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons"
import {
  DatePicker,
  Flex,
  Input,
  Select,
  Typography,
  Space,
  message,
} from "antd"
import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { getManagers } from "src/store/Slices/DropDownSlice"
import {
  editClent,
  getClientsList,
  changePassword,
} from "src/store/Slices/ClientsSlice"
import s from "./ChangePasswordModal.module.css"

const ChangePasswordModal = ({
  visible,
  setVisible,
  clientInfo,
  username,
  onSuccess,
}) => {
  const dispatch = useDispatch()

  const [password, setPassword] = useState("")
  const [newPassword1, setNewPassword1] = useState("")
  const [newPassword2, setNewPassword2] = useState("")
  const [checkNewPassword, setCheckPassword] = useState(true)

  // Функция для преобразования телефона в формат +79956958782
  const formatPhoneToRaw = (phone) => {
    if (!phone) return ""
    // Удаляем все символы, кроме цифр
    const digits = phone.toString().replace(/\D/g, "")
    
    // Если номер начинается с 8, заменяем на +7
    if (digits.length === 11 && digits.startsWith("8")) {
      return `+7${digits.slice(1)}`
    }
    
    // Если номер начинается с 7 и длина 11 цифр
    if (digits.length === 11 && digits.startsWith("7")) {
      return `+${digits}`
    }
    
    // Если номер уже в формате 79956958782 (10 цифр после 7)
    if (digits.length === 11) {
      return `+${digits}`
    }
    
    return phone
  }

  const onClickEditManager = async () => {
    if (!password) {
      message.error("Введите пароль")
      return
    }

    if (!newPassword1) {
      message.error("Введите новый пароль")
      return
    }

    if (!newPassword2) {
      message.error("Повторите новый пароль")
      return
    }

    if (newPassword1 !== newPassword2) {
      message.error("Новый пароль не совпадает")
      return
    }

    // Получаем сырой телефон в формате +79956958782
    const rawUsername = formatPhoneToRaw(clientInfo?.login || username)

    try {
      const result = await dispatch(
        changePassword({
          username: rawUsername, // телефон в формате +79956958782
          oldPassword: password,
          newPassword: newPassword1,
        }),
      )
      if (result.payload?.data?.isSuccess === true) {
        message.success("Пароль успешно изменен")
        setPassword("")
        setNewPassword1("")
        setNewPassword2("")
        setVisible(false)
        if (onSuccess) {
          onSuccess()
        }
      } else {
        message.error("Ошибка при изменении пароля")
      }
    } catch (error) {
      message.error(`Произошла ошибка: ${error}`)
    }
  }

  return (
    <>
      <CModal
        alignment='center'
        visible={visible}
        onClose={() => {
          setVisible(false)
          setPassword("")
          setNewPassword1("")
          setNewPassword2("")
        }}
        aria-labelledby='VerticallyCenteredExample'
      >
        <CModalHeader>
          <CModalTitle id='VerticallyCenteredExample'>Смена пароля</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <div className={s.changePasswordBody}>
            <span>Введите пароль</span>
            <Input.Password
              value={password}
              iconRender={(visible) =>
                visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
              }
              onChange={(e) => setPassword(e.target.value)}
              placeholder='Текущий пароль'
            />

            <span>Введите новый пароль</span>
            <Input.Password
              value={newPassword1}
              iconRender={(visible) =>
                visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
              }
              onChange={(e) => setNewPassword1(e.target.value)}
              placeholder='Новый пароль'
            />

            <span>Повторите новый пароль</span>
            <Input.Password
              value={newPassword2}
              status={
                newPassword2 && newPassword1 !== newPassword2 ? "error" : ""
              }
              iconRender={(visible) =>
                visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
              }
              onChange={(e) => setNewPassword2(e.target.value)}
              placeholder='Подтверждение пароля'
            />
            {newPassword2 && newPassword1 !== newPassword2 && (
              <div
                style={{ color: "red", fontSize: "12px", marginTop: "-8px" }}
              >
                Пароли не совпадают
              </div>
            )}
          </div>
        </CModalBody>
        <CModalFooter>
          <CButton
            color='secondary text-light'
            onClick={() => {
              setVisible(false)
              setPassword("")
              setNewPassword1("")
              setNewPassword2("")
            }}
          >
            Закрыть
          </CButton>
          <CButton color='primary text-light' onClick={onClickEditManager}>
            Сохранить
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default ChangePasswordModal